/**
 * Render all values for this flight property
 * @param {Array<string>} arr
 * @returns {String}
 */
export const renderStringArray = (arr?: Array<string>): string => {
  let value = "";

  if (arr === undefined) {
    return value;
  }

  if (arr.length === 1) {
    value = arr[0];
  }

  if (arr.length > 1) {
    value = arr.join(", ");
  }
  return value;
};

/**
 * Render chunks of size mentioned
 * @param {Array<string>} arr, @param {number | undefined} chunkSize
 * @returns {Array<string>}
 */

export const renderSplitStringArray = (arr?: Array<string>, chunkSize?: number): Array<string> => {
  chunkSize = chunkSize || 3;
  let chunk: string[] = [];

  // handle empty array
  if (!arr?.length) return [""];

  // when array is = chunk size return stringified array
  if (arr.length < chunkSize) {
    return (chunk = [renderStringArray(arr)]);
  }

  for (let i = 0; i < arr.length; i += chunkSize) {
    chunk.push(renderStringArray(arr.slice(i, i + chunkSize)));
  }

  return chunk;
};
